(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["blog-search-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('blog-search')) {
    class BlogSearch extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[name="q"]');
        this.results = this.querySelector('.blog-search__results');
        this.status = this.querySelector('[data-search-status]');
        this.url = this.dataset.suggestUrl || '/search/suggest.json';
        this.active = -1;
        this.cache = new Map();

        this.input.addEventListener('input', () => {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.search(), 200);
        });
        this.input.addEventListener('keydown', (e) => this.onKey(e));
        this.input.addEventListener('focus', () => {
          if (this.results.childElementCount && this.input.value.trim()) this.open();
        });
        document.addEventListener('click', (e) => {
          if (!this.contains(e.target)) this.close();
        });
        this.form.addEventListener('submit', (e) => {
          if (!this.input.value.trim()) {
            e.preventDefault();
            this.input.focus();
          }
        });
      }

      get options() {
        return [...this.results.querySelectorAll('[role="option"]')];
      }

      async search() {
        const q = this.input.value.trim();
        if (q.length < 2) {
          this.close();
          return;
        }

        try {
          let articles = this.cache.get(q);
          if (!articles) {
            const params = new URLSearchParams({
              q,
              'resources[type]': 'article',
              'resources[limit]': '6',
              'resources[options][prefix]': 'last',
            });
            this.abort?.abort();
            this.abort = new AbortController();
            const response = await fetch(`${this.url}?${params}`, { signal: this.abort.signal });
            if (!response.ok) throw new Error(`Search ${response.status}`);
            const data = await response.json();
            articles = data?.resources?.results?.articles || [];
            this.cache.set(q, articles);
          }
          if (q !== this.input.value.trim()) return;
          this.render(q, articles);
        } catch (error) {
          if (error.name !== 'AbortError') console.warn('[blog-search]', error);
        }
      }

      render(q, articles) {
        const listId = this.results.id;
        this.results.replaceChildren();
        this.active = -1;

        if (!articles.length) {
          const empty = document.createElement('p');
          empty.className = 'blog-search__empty';
          empty.textContent = `No articles match “${q}” yet.`;
          this.results.append(empty);
        }

        articles.forEach((article, i) => {
          const link = document.createElement('a');
          link.className = 'blog-search__option';
          link.href = article.url;
          link.id = `${listId}-opt-${i}`;
          link.setAttribute('role', 'option');
          link.setAttribute('aria-selected', 'false');

          const thumb = document.createElement(article.image ? 'img' : 'span');
          thumb.className = 'blog-search__thumb';
          if (article.image) {
            const src = new URL(article.image, window.location.origin);
            src.searchParams.set('width', '120');
            thumb.src = src.toString();
            thumb.alt = '';
            thumb.loading = 'lazy';
            thumb.width = 52;
            thumb.height = 52;
          }

          const title = document.createElement('span');
          title.className = 'blog-search__option-title';
          title.append(...highlight(article.title, q));

          link.append(thumb, title);
          this.results.append(link);
        });

        const all = document.createElement('a');
        all.className = 'blog-search__all';
        all.id = `${listId}-opt-all`;
        all.setAttribute('role', 'option');
        all.setAttribute('aria-selected', 'false');
        const params = new URLSearchParams({ q, type: 'article', 'options[prefix]': 'last' });
        all.href = `${this.form.getAttribute('action')}?${params}`;
        all.textContent = `See all results for “${q}”`;
        this.results.append(all);

        this.status.textContent = articles.length
          ? `${articles.length} matching article${articles.length === 1 ? '' : 's'}. Use the arrow keys to browse.`
          : 'No matching articles.';
        this.open();
      }

      onKey(e) {
        const options = this.options;
        if (this.results.hidden || !options.length) return;

        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          const step = e.key === 'ArrowDown' ? 1 : -1;
          this.active = (this.active + step + options.length) % options.length;
          options.forEach((opt, i) => opt.setAttribute('aria-selected', i === this.active ? 'true' : 'false'));
          this.input.setAttribute('aria-activedescendant', options[this.active].id);
          options[this.active].scrollIntoView({ block: 'nearest' });
        } else if (e.key === 'Enter' && this.active > -1) {
          e.preventDefault();
          window.location.href = options[this.active].href;
        } else if (e.key === 'Escape') {
          this.close();
        }
      }

      open() {
        this.results.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
      }

      close() {
        this.results.hidden = true;
        this.input.setAttribute('aria-expanded', 'false');
        this.input.removeAttribute('aria-activedescendant');
        this.active = -1;
      }
    }

    function highlight(text, q) {
      const terms = q.split(/\s+/).filter(Boolean).map((t) => t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
      if (!terms.length) return [document.createTextNode(text)];
      const parts = text.split(new RegExp(`(${terms.join('|')})`, 'gi'));
      return parts.map((part, i) => {
        if (i % 2 === 1) {
          const mark = document.createElement('mark');
          mark.textContent = part;
          return mark;
        }
        return document.createTextNode(part);
      });
    }

    customElements.define('blog-search', BlogSearch);
  }
  } catch(e) { console.error(e); }
})();

})();
